module.exports = __webpack_public_path__ + "static/media/image_placeholder.956f53b9.jpg";